import { Component, Input, AfterContentInit } from '@angular/core';


@Component({
  selector: 'zoom-header',
  templateUrl: './zoom-header.component.html',
  styleUrls: ['./zoom-header.component.scss']
})
export class ZoomHeaderComponent implements AfterContentInit {


  @Input() raetId: string;
  @Input() backgroundColor: string;

  ngAfterContentInit() {
      this.isValid();
  }

  isValid() {
    if (!this.raetId) {
        console.error('component is not correctly binding, zoom-header raet id missing');
    }
  }


}
